import React from "react";
import {Route, Switch} from "react-router-dom";
import ExternalFilteredMentorList from "../../../../modules/ExternalFilteredMentorList/ExternalFilteredMentorList";
import {ProductOpenedEventWrapper} from "../../../../shared/components/ProductOpenedEventWrapper";
import ExternalHeader from "./ExternalHeader/ExternalHeader";

const ExternalMentorCardWidgetRoutes = (parentProps) => {
    // we use these to set the back navigation to list of buddies only for ext buddies carousel
    const [initialUrl] = React.useState(parentProps.location.pathname);
    const [isCarousel] = React.useState(
        parentProps.location.pathname.indexOf("/external/carousel") > -1,
    );
    return (
        <Switch>
            <Route
                exact
                path={`${parentProps.match.path}/buddies/:filter/:value+`}
                render={(props) => (
                    <ProductOpenedEventWrapper>
                        <ExternalFilteredMentorList {...parentProps} {...props} />
                    </ProductOpenedEventWrapper>
                )}
            />
            <Route
                exact
                path={`${parentProps.match.path}/carousel/buddies/:filter/:value+`}
                render={(props) => (
                    <ProductOpenedEventWrapper>
                        <ExternalFilteredMentorList {...parentProps} {...props} isCarousel />
                    </ProductOpenedEventWrapper>
                )}
            />
            <Route
                path={`${parentProps.match.path}`}
                render={(props) => (
                    <ExternalHeader
                        {...parentProps}
                        {...props}
                        carouselUrl={initialUrl}
                        isCarousel={isCarousel}
                    />
                )}
            />
        </Switch>
    );
};

export default ExternalMentorCardWidgetRoutes;
